import { render, staticRenderFns } from "./PromotionCheck.vue?vue&type=template&id=2e7c81d8&"
import script from "./PromotionCheck.vue?vue&type=script&lang=js&"
export * from "./PromotionCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports